import { type TextFieldProps } from '@sapphire-react/core';
import { NumberField } from '@sapphire-react/lab';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { useSapphireMedia } from '../hooks';
import { FormFieldProps } from '../types';
import { MaskedNumberField } from './MaskedNumberField';

type Props = Omit<TextFieldProps, 'name'> & {
  name: string;
  min?: number;
  max?: number;
  type?: 'number' | 'string';
} & FormFieldProps;

export function AmountInputField(props: Props) {
  const {
    control,
    name,
    rules,
    type,
    label,
    defaultValue,
    onChange,
    error: err,
    ...rest
  } = props;
  const { isExtraSmall, isSmall } = useSapphireMedia();

  return (
    <Wrapper>
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue || undefined}
        render={({
          field: { ref: _ref, onChange: _onChange, value, ...field },
          fieldState: { error },
        }) =>
          type === 'number' ? (
            <NumberField
              width={'100%'}
              size={isExtraSmall || isSmall ? 'md' : 'lg'}
              label={label}
              minValue={rest.min}
              maxValue={rest.max}
              affix={{
                postfix: rest.postfix,
              }}
              alignInputRight
              contextualHelp={rest.contextualHelp}
              defaultValue={Number(defaultValue)}
              data-test-id={`${name}-AmountInput`}
              onChange={(value) => {
                _onChange(value.toString());
                onChange?.(value.toString());
              }}
            />
          ) : (
            <MaskedNumberField
              type={type}
              label={label}
              defaultValue={defaultValue}
              {...field}
              {...rest}
              value={value}
              error={error?.message || err}
              onChange={(value) => {
                _onChange(value);
                onChange?.(value);
              }}
            />
          )
        }
      />
    </Wrapper>
  );
}

//to fix sitecore overriding styles of label element
const Wrapper = styled.div`
  label {
    display: inline;
  }
`;
